/*

 MIT License

 Copyright (c) 2022 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */


/**
 * NOTE: This is an auto-generated file changes within may be overwritten
 * Run `yarn workspace @looker/icons build` to update
 */

import React from 'react'
import type { StyledIcon, StyledIconProps } from '@styled-icons/styled-icon'
import { StyledIconBase } from '@styled-icons/styled-icon'

export const CalendarQuarter: StyledIcon = React.forwardRef<
  SVGSVGElement,
  StyledIconProps
>((props, ref) => {
  const attrs: React.SVGProps<SVGSVGElement> = {
      "fill": "currentColor",
  "xmlns": "http://www.w3.org/2000/svg",
  }

  return (
    <StyledIconBase
      iconAttrs={attrs}
      iconVerticalAlign="middle"
      iconViewBox="0 0 24 24"
      {...props}
      ref={ref}
    >
      <path d="M21 6V20C21 21.1 20.1 22 19 22H5C3.89 22 3 21.1 3 20L3.01 6C3.01 4.9 3.89 4 5 4H6V2H8V4H16V2H18V4H19C20.1 4 21 4.9 21 6ZM5 8H19V6H5V8ZM19 20V10H5V20H19Z" />

      <path d="M8.44766 17.1445C8.74974 17.1445 8.97109 17.0586 9.11172 16.8867C9.25234 16.7122 9.32917 16.4089 9.34219 15.9766V15.832C9.34219 15.3633 9.26927 15.0273 9.12344 14.8242C8.98021 14.6211 8.74844 14.5195 8.42812 14.5195C7.86823 14.5195 7.58828 14.9596 7.58828 15.8398C7.58828 16.2773 7.65729 16.6042 7.79531 16.8203C7.93594 17.0365 8.15339 17.1445 8.44766 17.1445ZM8.02187 18.0781C7.50625 18.0781 7.1026 17.8802 6.81094 17.4844C6.51927 17.0859 6.37344 16.5326 6.37344 15.8242C6.37344 15.1107 6.52187 14.5534 6.81875 14.1523C7.11823 13.7513 7.52708 13.5508 8.04531 13.5508C8.32135 13.5508 8.56224 13.6029 8.76797 13.707C8.9737 13.8112 9.15469 13.9727 9.31094 14.1914H9.34219L9.44766 13.6328H10.4555V19.9219H9.26016V18.0898C9.26016 17.931 9.27708 17.7122 9.31094 17.4336H9.26016C9.13255 17.6445 8.96328 17.8047 8.75234 17.9141C8.54141 18.0234 8.29792 18.0781 8.02187 18.0781ZM13.1414 17.1289C13.3497 17.1289 13.5997 17.0833 13.8914 16.9922V17.8789C13.5945 18.0117 13.2299 18.0781 12.7977 18.0781C12.3211 18.0781 11.9734 17.9583 11.7547 17.7188C11.5385 17.4766 11.4305 17.1146 11.4305 16.6328V14.5273H10.8602V14.0234L11.5164 13.625L11.8602 12.7031H12.6219V13.6328H13.8445V14.5273H12.6219V16.6328C12.6219 16.8021 12.6687 16.9271 12.7625 17.0078C12.8589 17.0885 12.9852 17.1289 13.1414 17.1289ZM16.8156 13.5508C16.9771 13.5508 17.1112 13.5625 17.218 13.5859L17.1281 14.7031C17.0318 14.6771 16.9146 14.6641 16.7766 14.6641C16.3964 14.6641 16.0995 14.7617 15.8859 14.957C15.675 15.1523 15.5695 15.4258 15.5695 15.7773V18H14.3781V13.6328H15.2805L15.4562 14.3672H15.5148C15.6503 14.1224 15.8326 13.9258 16.0617 13.7773C16.2935 13.6263 16.5448 13.5508 16.8156 13.5508Z" />

    </StyledIconBase>
  )
})

CalendarQuarter.displayName = 'CalendarQuarter'

export const CalendarQuarterDimensions = {height: 24, width: 24}
